export const webHost = 'https://termvet.com';
export const version = 'master (a95d2ea004b1d3edf34c0c11666dbe132e39ef1b)';